import { getDiscountValue } from '../../utils/price';
import getPriceStripped from './priceUtils';
import { readCookie } from '../../components/common/Cookie';
import { getStoreName } from '../../modules/ga/GTMdatalayer';
import { catalogIdToStoreName } from '../../utils';
import { getDateRangeForGA } from '../../edd/utils/getDateRange';
import { deliveryMethod as DELIVERY_METHOD } from '../constants/ordersData.constants';
import { getProductAttributionToken, getCopilotSkuCheck, getCrossSellWidgetSource } from '../../utils/common';

const itemLabelDetails = itemDetails => {
  const segmentExperimentData = JSON.parse(localStorage.getItem('segmentExperiment'));
  const products = itemDetails.map(row => {
    const {
      brandName = '',
      brickCategory: Category = '',
      code: skuId = '',
      color = '',
      name: skuName = '',
      quantity = '',
      size = '',
      baseProduct = '',
      catalogName = '',
      priceInfo: {
        couponSaving: { formattedValue: couponSaving = '' } = {},
        discount: { value: discount = '' } = {},
        discountPercentage = '',
        totalSaving: { formattedValue: totalSaving = '' } = {},
        originalPrice: { formattedValue: originalPrice = '', value: wasPrice } = {},
        netPrice: { formattedValue: netPrice = '', value: finalPrice } = {}
      } = {},
      offers = {},
      isGiftProduct = false,
      eddLower = '',
      eddUpper = '',
      isMembershipArticle = false,
      giftProductsCount = 0
    } = row;
    const localSegmentId = segmentExperimentData?.filter(el => el.code === row.code)[0]?.segmentId;
    const localExperimentId = segmentExperimentData?.filter(el => el.code === row.code)[0]
      ?.experimentId;
    return {
      brandName,
      Category,
      skuId,
      color,
      discount,
      wasPrice,
      finalPrice,
      skuName,
      quantity,
      size,
      couponSaving,
      discountPercentage,
      totalSaving,
      originalPrice,
      netPrice,
      baseProduct,
      offers,
      catalogName,
      segmentId: localSegmentId,
      experimentId: localExperimentId,
      isGiftProduct,
      eddLower,
      eddUpper,
      isMembershipArticle,
      giftProductsCount
    };
  });
  return products;
};

const purchaseData = (
  order,
  enableGiftWithProduct,
  isPriorityDeliveryFlagOn,
  enableSubscription,
  membershipSavings,
  enablePDPhase2,
  enableRushDelivery,
  PLP_BUCKET
) => {
  const { code = '', orderSummary = {}, item = [], entries = [] } = order;
  const {
    orderTotal: { formattedValue: orderTotal = '' } = {},
    deliveryCharge: { formattedValue: deliveryCharge = '' } = {},
    exclusiveGSTCharge: { formattedValue: exclusiveGSTAmt = '' } = {},
    couponSaving: { formattedValue: couponSaving = '' } = {}
  } = orderSummary;
  const products = itemLabelDetails(item);
  const revenue = orderTotal ? getPriceStripped(orderTotal) : 0;
  const tax = exclusiveGSTAmt ? getPriceStripped(exclusiveGSTAmt) : 0;
  const shipping = deliveryCharge ? getPriceStripped(deliveryCharge) : 0;
  const coupon = couponSaving ? getPriceStripped(couponSaving) : 0;
  let gtmCoupon = '';
  let gtmTotalDiscount = '';
  let gtmMRP = '';
  let gtmNetPrice = '';
  const purchaseProducts = [];
  const { offers = {} } = products[0];
  const { appliedVouchers } = offers;
  let appliedCode = '';
  if (offers.appliedVouchers) {
    appliedCode = appliedVouchers[0]?.code;
  }
  products
    .filter(x => !x.isGiftProduct)
    .forEach((item, i) => {
      const {
        brandName,
        Category,
        skuId,
        discount,
        wasPrice,
        finalPrice,
        color,
        skuName,
        quantity,
        size,
        couponSaving,
        totalSaving,
        originalPrice,
        netPrice,
        baseProduct = '',
        discountPercentage,
        averageRating,
        numUserRatings = '',
        catalogName = '',
        segmentId = '',
        experimentId = '',
        code: productCode,
        eddLower = '',
        eddUpper = '',
        isGstEligible = false
      } = item;
      gtmCoupon = couponSaving ? getPriceStripped(couponSaving) : '';
      gtmTotalDiscount = totalSaving ? getPriceStripped(totalSaving) : '';
      gtmMRP = originalPrice ? getPriceStripped(originalPrice) : '';
      gtmNetPrice = netPrice ? getPriceStripped(netPrice) : '';
      const [productId, variant] =
        baseProduct && baseProduct?.includes && baseProduct.includes('_')
          ? baseProduct.split('_')
          : [baseProduct || '', baseProduct || ''];
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';

      let giftCount = 0;
      if (enableGiftWithProduct) {
        const mainProduct = entries.find(x => x?.product?.code === skuId);
        giftCount = mainProduct?.giftProductsCount || 0;
      }

      const pincode = order?.deliveryInfo?.deliveryAddress?.postalCode || '';
      const entry = entries.find(x => x.product.code === item.skuId);
      let rushDeliveryFee = 0;
      let rushDeliveryEDD = '';
      let rushDeliverySLA = '';
      if (enableRushDelivery) {
        if (entry.deliveryMethod === DELIVERY_METHOD.RUSH) {
          rushDeliverySLA = entries[i]?.deliverySLA;
          rushDeliveryFee = entry?.convenienceFee?.rushDelivery?.netAmount || 0;
          rushDeliveryEDD = getDateRangeForGA({ eddLower, eddUpper }) || '';
        }
      }

      let priorityDeliveryFee = 0;
      let priorityDeliveryEDD = '';
      let priorityDeliverySLA = '';
      if (isPriorityDeliveryFlagOn) {
        const isPriorityDeliveryApplied = enableRushDelivery
          ? entry.deliveryMethod === DELIVERY_METHOD.PRIORITY
          : entry.isPriorityDeliveryApplied;
        if (isPriorityDeliveryApplied) {
          priorityDeliverySLA = entries[i]?.deliverySLA;
          priorityDeliveryFee = entry?.convenienceFee?.priorityDelivery?.netAmount || 0;
          priorityDeliveryEDD = getDateRangeForGA({ eddLower, eddUpper }) || '';
        }
      }
      const itemToken = getProductAttributionToken(skuId);
      const copilotToken = getCopilotSkuCheck(skuId);
      const crossSellWidgetTitle = getCrossSellWidgetSource(baseProduct);
      purchaseProducts.push({
        name: skuName,
        id: baseProduct?.split('_')[0] || skuId,
        skuId,
        brand: brandName,
        category: Category,
        variant: baseProduct?.split('_')[1] || color || variant,
        quantity,
        discount,
        wasPrice,
        finalPrice,
        coupon: gtmCoupon ? parseFloat(gtmCoupon.replace(',', '')) : 0,
        totalDiscount: gtmTotalDiscount ? parseFloat(gtmTotalDiscount.replace(',', '')) : 0,
        MRP: gtmMRP ? parseFloat(gtmMRP.replace(',', '')) : 0,
        price: gtmNetPrice ? parseFloat(gtmNetPrice.replace(',', '')) : 0,
        size,
        isMembershipArticle: item?.isMembershipArticle,
        dimension12: productId,
        dimension13: skuName,
        dimension14: '',
        dimension15: Category,
        dimension16: Category,
        dimension20: '',
        dimension21: brandName,
        dimension22: gtmNetPrice ? parseFloat(gtmNetPrice.replace(',', '')) : 0,
        dimension23: catalogIdToStoreName(catalogName),
        dimension24: size,
        dimension60: dimension60Data,
        dimension170: getDiscountValue(discountPercentage),
        ...(pincode && { pincode }),
        ...(averageRating &&
          numUserRatings && { dimension46: `${averageRating}|${numUserRatings}` }),
        ...(giftCount > 0 && { dimension166: `GetFreebies - ${giftCount}` }),
        ...(isPriorityDeliveryFlagOn && { priorityDeliveryEDD, priorityDeliveryFee }),
        ...(enablePDPhase2 &&
          priorityDeliverySLA && { priority_delivery_sla_tag: PLP_BUCKET[priorityDeliverySLA] }),
        ...(enableRushDelivery && { rushDeliveryEDD, rushDeliveryFee }),
        ...(enableRushDelivery &&
          rushDeliverySLA && { rush_delivery_sla_tag: PLP_BUCKET[rushDeliverySLA] }),
        ...(enableSubscription && {
          subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
          subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
          subscription_total_savings: membershipSavings?.totalMembershipSavings,
          subscription_membership_discount: membershipSavings?.membershipDiscount
        }),
        ...(itemToken && { search_attribution: itemToken }),
        ...(copilotToken === 'copilot' && { itm_source_detail: 'ai_assistant_widget' }),
        ...(crossSellWidgetTitle && { itm_source: 'widget', itm_source_detail: crossSellWidgetTitle })
      });
    });
  return {
    code,
    revenue,
    tax,
    shipping,
    coupon,
    purchaseProducts,
    appliedCode
  };
};

const luxePurchaseData = (
  order,
  enableGiftWithProduct,
  isPriorityDeliveryFlagOn,
  enablePDPhase2,
  enableRushDelivery,
  PLP_BUCKET,
  enableSubscription,
  membershipSavings
) => {
  const { code = '', orderSummary = {}, item = [], entries = [] } = order;
  const {
    orderTotal: { formattedValue: orderTotal = '' } = {},
    deliveryCharge: { formattedValue: deliveryCharge = '' } = {},
    exclusiveGSTCharge: { formattedValue: exclusiveGSTAmt = '' } = {},
    couponSaving: { formattedValue: couponSaving = '' } = {}
  } = orderSummary;
  const products = itemLabelDetails(item);
  const revenue = orderTotal ? getPriceStripped(orderTotal) : 0;
  const itemRevenue = Number(revenue?.split(',').join(''));
  const tax = exclusiveGSTAmt ? getPriceStripped(exclusiveGSTAmt) : 0;
  const shipping = deliveryCharge ? getPriceStripped(deliveryCharge) : 0;
  const coupon = couponSaving ? getPriceStripped(couponSaving) : 0;
  let gtmCoupon = '';
  let gtmTotalDiscount = '';
  let gtmMRP = '';
  let gtmNetPrice = '';
  const purchaseProducts = [];
  const { offers = {} } = products[0];
  const { appliedVouchers } = offers;
  let appliedCode = '';
  if (offers.appliedVouchers) {
    appliedCode = appliedVouchers[0]?.code;
  }

  // if (appliedVouchers) {
  //   // const applieappliedVouchers[0]?.code
  //   // appliedCode = appliedVouchers[0].code
  // }
  // const appliedCode = appliedVouchers[0]?.code || '';
  products
    .filter(x => !x.isGiftProduct)
    .forEach((item, i) => {
      const {
        brandName,
        Category,
        skuId,
        color,
        skuName,
        quantity,
        discount,
        wasPrice,
        finalPrice,
        size,
        couponSaving,
        totalSaving,
        originalPrice,
        netPrice,
        baseProduct = '',
        exclusiveTill,
        offers,
        catalogName = '',
        segmentId = '',
        experimentId = '',
        code: productCode,
        eddLower = '',
        eddUpper = ''
      } = item;
      const { appliedVouchers } = offers;
      // let couponCode = '';
      // if (appliedVouchers) {
      const couponCode = appliedVouchers ? appliedVouchers[0]?.code : '';
      // }
      // const couponCode = appliedVouchers[0]?.code;
      const tag = exclusiveTill ? 'Exclusive' : '';
      gtmCoupon = couponSaving ? getPriceStripped(couponSaving) : '';
      gtmTotalDiscount = totalSaving ? getPriceStripped(totalSaving) : '';
      gtmMRP = originalPrice ? getPriceStripped(originalPrice) : '';
      gtmNetPrice = netPrice ? getPriceStripped(netPrice) : '';
      const [productId, variant] =
        baseProduct && baseProduct?.includes && baseProduct.includes('_')
          ? baseProduct.split('_')
          : [baseProduct || '', baseProduct || ''];
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      const itemId = baseProduct?.split('_')[0] || '';
      const crossSellWidgetTitle = getCrossSellWidgetSource(baseProduct);

      let giftCount = 0;
      if (enableGiftWithProduct) {
        const mainProduct = entries.find(x => x?.product?.code === skuId);
        giftCount = mainProduct?.giftProductsCount || 0;
      }

      const pincode = order?.deliveryInfo?.deliveryAddress?.postalCode || '';
      const entry = entries.find(x => x.product.code === item.skuId);

      let rushDeliveryFee = 0;
      let rushDeliveryEDD = '';
      let rushDeliverySLA = '';
      if (enableRushDelivery) {
        if (entry.deliveryMethod === DELIVERY_METHOD.RUSH) {
          rushDeliverySLA = entries[i]?.deliverySLA;
          rushDeliveryFee = entry?.convenienceFee?.rushDelivery?.netAmount || 0;
          rushDeliveryEDD = getDateRangeForGA({ eddLower, eddUpper }) || '';
        }
      }

      let priorityDeliveryFee = 0;
      let priorityDeliveryEDD = '';
      let priorityDeliverySLA = '';
      if (isPriorityDeliveryFlagOn) {
        const isPriorityDeliveryApplied = enableRushDelivery
          ? entry.deliveryMethod === DELIVERY_METHOD.PRIORITY
          : entry.isPriorityDeliveryApplied;
        if (isPriorityDeliveryApplied) {
          priorityDeliverySLA = entries[i]?.deliverySLA;
          priorityDeliveryFee = entry?.convenienceFee?.priorityDelivery?.netAmount || 0;
          priorityDeliveryEDD = getDateRangeForGA({ eddLower, eddUpper }) || '';
        }
      }

      purchaseProducts.push({
        name: skuName,
        id: itemId,
        brand: brandName,
        category: Category,
        variant: color || variant,
        quantity,
        discount,
        wasPrice,
        finalPrice,
        isMembershipArticle: item?.isMembershipArticle,
        // coupon: gtmCoupon ? parseFloat(gtmCoupon.replace(',', '')) : 0,
        coupon: couponCode,
        totalDiscount: gtmTotalDiscount ? parseFloat(gtmTotalDiscount.replace(',', '')) : 0,
        MRP: gtmMRP ? parseFloat(gtmMRP.replace(',', '')) : 0,
        price: gtmNetPrice ? parseFloat(gtmNetPrice.replace(',', '')) : 0,
        size,
        dimension6: skuName,
        dimension7: itemId,
        dimension8: brandName,
        dimension9: gtmNetPrice,
        dimension10: variant,
        dimension11: size,
        dimension12: gtmTotalDiscount,
        dimension13: Category,
        // dimension13: gtmNetPrice ? parseFloat(gtmNetPrice.replace(',', '')) : 0,
        // dimension14: gtmTotalDiscount ? parseFloat(gtmTotalDiscount.replace(',', '')) : 0,
        dimension14: '',
        dimension15: tag,
        dimension16: 'luxe',
        dimension23: catalogIdToStoreName(catalogName),
        dimension60: dimension60Data,
        ...(pincode && { pincode }),
        ...(giftCount > 0 ? { dimension82: `GetFreebies - ${giftCount}` } : {}),
        ...(isPriorityDeliveryFlagOn && { priorityDeliveryEDD, priorityDeliveryFee }),
        ...(enablePDPhase2 &&
          priorityDeliverySLA && { priority_delivery_sla_tag: PLP_BUCKET[priorityDeliverySLA] }),
        ...(enableRushDelivery && { rushDeliveryEDD, rushDeliveryFee }),
        ...(enableRushDelivery &&
          rushDeliverySLA && { rush_delivery_sla_tag: PLP_BUCKET[rushDeliverySLA] }),
        ...(enableSubscription && {
          subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
          subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
          subscription_total_savings: membershipSavings?.totalMembershipSavings,
          subscription_membership_discount: membershipSavings?.membershipDiscount
        }),
        ...(crossSellWidgetTitle && {
          itm_source: 'widget',
          itm_source_detail: crossSellWidgetTitle
        }),
        skuId,
        giftCount
      });
    });
  return {
    code,
    itemRevenue,
    tax,
    shipping,
    appliedCode,
    purchaseProducts
  };
};

const getGstBillingAddress = (order: any = {}) => {
  const { gstDetails = {} } = order || {};
  const { gstNumber = '', businessName = '', address = {} } = gstDetails || {};
  return {
    name: businessName,
    address: address?.formattedAddress || '',
    phone: address?.phone1 || address?.phone || '',
    gstin: gstNumber,
    gstApplicable: true
  };
};

const getGstShippingAddress = (order: any = {}) => {
  const { gstDetails = {}, deliveryInfo = {} } = order || {};
  const { shipToGstNumber = '', shipToBusinessName = '' } = gstDetails || {};
  const deliveryAddress = deliveryInfo?.deliveryAddress || order?.deliveryAddress || {};
  const recipientName = `${deliveryAddress?.firstName || ''} ${deliveryAddress?.lastName || ''}`.trim();
  return {
    name: shipToBusinessName || recipientName || deliveryAddress?.addressPoc || '',
    address: deliveryAddress?.formattedAddress || '',
    phone: deliveryAddress?.phone || '',
    gstin: shipToGstNumber,
    gstApplicable: Boolean(shipToGstNumber)
  };
};

/**
 * Builds the GST billing/shipping payload carried to the payment page via bannerInfo.
 * Works off a cart (shipping flow) or order (retry flow) entity:
 *  - billing  ← entity.gstDetails (registered GST address)
 *  - shipping ← entity.deliveryInfo.deliveryAddress (or entity.deliveryAddress)
 * Returns null when there is no meaningful GST detail, so callers can skip it.
 */
const buildBannerGstInfo = (entity: any = {}, addressGstLabel = '', gstNonApplicableLabel = '') => {
  const { gstDetails = {}, gstInfoMessage = {}, deliveryInfo = {} } = entity || {};
  const deliveryAddress = deliveryInfo?.deliveryAddress || entity?.deliveryAddress || {};

  const billingAddr = gstDetails?.address || {};
  const billingFormattedAddress =
    billingAddr?.formattedAddress ||
    [billingAddr?.line1, billingAddr?.line2, billingAddr?.postalCode].filter(Boolean).join(', ');

  const billingAddress = {
    businessName: gstDetails?.businessName || '',
    gstNumber: gstDetails?.gstNumber || '',
    formattedAddress: billingFormattedAddress,
    phone: billingAddr?.phone1 || billingAddr?.phone || ''
  };

  const recipientName = `${deliveryAddress?.firstName || ''} ${deliveryAddress?.lastName ||
    ''}`.trim();
  const shippingAddress = {
    businessName:
      deliveryAddress?.businessName || recipientName || deliveryAddress?.addressPoc || '',
    gstNumber: deliveryAddress?.gstNumber || '',
    formattedAddress: deliveryAddress?.formattedAddress || '',
    phone: deliveryAddress?.phone || ''
  };

  if (!billingAddress.gstNumber && !shippingAddress.gstNumber && !gstInfoMessage?.value) {
    return null;
  }
  return { billingAddress, shippingAddress, gstInfoMessage, addressGstLabel, gstNonApplicableLabel };
};

/**
 * Billing GST is treated as expired when any cancelled entry or return request carries
 * gstDetails.valid === false — same condition the ODP page (GstInfoMobile) uses.
 */
const getGstBillingExpired = (order: any = {}) => {
  const { cancelledEntries = [], consignmentsData = [] } = order || {};
  const cancelledExpired = cancelledEntries?.some((item: any) => item?.gstDetails?.valid === false);
  const returnExpired = consignmentsData?.some((consignment: any) =>
    consignment?.returnRequests?.some((el: any) => el?.gstDetails?.valid === false)
  );
  return Boolean(cancelledExpired || returnExpired);
};

export {
  purchaseData,
  luxePurchaseData,
  getGstBillingAddress,
  getGstShippingAddress,
  buildBannerGstInfo,
  getGstBillingExpired
};
